import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetProject } from '../projects.queries';
import { ProjectDetailContent } from './components/project-detail-content';

export function ProjectDetail() {
  const { t } = useTranslation('projects');
  const { projectId } = useParams<{ projectId: string }>();
  const { data: project, isLoading } = useGetProject(projectId ? parseInt(projectId) : null);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">{t('detail.loading')}</p>
        </div>
      </div>
    );
  }

  if (!project) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <h2 className="text-xl font-bold mb-2">{t('detail.notFoundTitle')}</h2>
          <p className="text-muted-foreground">{t('detail.notFoundDescription')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full">
      <ProjectDetailContent project={project} />
    </div>
  );
}
